module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/logo_tvb-8af010fe1f49e261c6423dcbc649c0ba.svg";